import { To, useLocation, useNavigate } from "react-router-dom";

export const useNavigateBack = (fallback: To) => {
  const location = useLocation();

  const navigate = useNavigate();

  const canGoBack = location.key !== "default";

  if (canGoBack) return () => navigate(-1);

  return () => navigate(fallback);
};
